import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatosSimulacionSaludComponent } from '../../components/datos-simulacion-salud/datos-simulacion-salud.component';

@Component({
	selector: 'app-datos-simulacion-dental',
	standalone: true,
	imports: [
		CommonModule,
		DatosSimulacionSaludComponent
	],
	templateUrl: './datos-simulacion-dental.view.html',
	styleUrls: ['./datos-simulacion-dental.view.scss']
})
export class DatosSimulacionDentalView {}
